export const CARD_HEIGHT_SM = 234;
export const CARD_HEIGHT_LG = 312;

export const CARD_WIDTH_SM = 206;
export const CARD_WIDTH_LG = 276;

export const CARD_GAP_SM = 12;
export const CARD_GAP_LG = 16;

export const CARD_COLS_COUNT = 2;
